
export const Radiobox = ({ checked, name, id, onChange, disabled, onClick }) => {
    return (
        <input type="radio" name={name} id={id} checked={checked} onChange={onChange} onClick={onClick}  disabled={disabled} className="w100" />
    );
};

export function Modal({ children, shown, close }) {
    return shown ? (
        <div className="modal-backdrop" onClick={() => {close();}}>
            <div className="modal-content-demo"
                 onClick={e => {
                     e.stopPropagation();
                 }}
            >
                <div className="modal-close" onClick={close}>×</div>
                {children}
            </div>
        </div>
    ) : null;
}